import { User } from '../types/app.types';

export const getInitialUserState = (): User => {
  return {
    email: '',
    role: '',
  };
};
